"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(values, response) {
  // const groups = values.groups ? values.groups : [];
  var group = values.group ? values.group : 0;
  var role = values.role ? values.role : '';

  // values to start from
  var available = true;
  if ({}.hasOwnProperty.call(response, 'data')) {
    response = response.data;
  }
  if ({}.hasOwnProperty.call(response, 'available') && !response.available) {
    available = false;
  }
  if (available && response.exists) {
    // unavailable -----------------------------

    // a pawn you are not allowed to add
    if (response.exists && (response.pawns === null || response.user === null)) {
      available = false;
    }

    // a user exists and all pawns have the same groups and roles
    if (!(0, _isEmpty2["default"])((0, _filter2["default"])(response.pawns, function (p) {
      return (!p.group || group === p.group.id) && p.role.handle === role;
    }))) {
      available = false;
    }
  }
  return {
    available: available,
    user: response.user
  };
};